import { FC } from "react";
import { closeIconSize } from "./constants";
import CloseRemoveIcon from "@svg/new-design/close-remove";
import { TagContentProps } from "./types";

const TagContent: FC<TagContentProps> = ({
  size,
  startIcon,
  endIcon,
  showTagClose,
  handleCloseClick,
  children,
}) => {
  return (
    <>
      {startIcon || null}
      {children}
      {endIcon || null}

      {showTagClose && (
        <CloseRemoveIcon
          onClick={handleCloseClick}
          className={closeIconSize[size]}
        />
      )}
    </>
  );
};

export default TagContent;
